import { createSlice } from "@reduxjs/toolkit"

// Define initial state for the slice.
const initialState = {
  monitorStock: { error: null, loading: false, data: [] },
  monitorStockExport: { error: null, loading: false },
  MonitorIps: { error: null, loading: false, data: [] },
  MonitorItemCategoires: { error: null, loading: false, data: [] },
  MonitorCommodityClassifications: { error: null, loading: false, data: [] },
  MonitorItems: { error: null, loading: false, data: [] },
  MonitorInItems: { data: [], error: null, loading: null },
  MonitorOutItems: { data: [], error: null, loading: null },
  monitorIpsStock: { error: null, loading: false, data: [] },
  monitorIpsStockExport: { error: null, loading: false },
  monitorWarehouses: { error: null, loading: false, data: [] },
  monitorProviders: { error: null, loading: false, data: [] },
  monitorProvinces: { error: null, loading: false, data: [] },
  monitorFacilities: { error: null, loading: false, data: [] },
  monitorProjects: { error: null, loading: false, data: [] },
  monitorProviderUsers: { error: null, loading: false, data: [] },
  monitorFundCodes: { error: null, loading: false, data: [] },
  monitorShipments: { error: null, loading: false, data: [] },
  monitorDashboardConfig: { loading: false, error: null, data: null },
  realtime: {
    exportState: { loading: false, error: null },
  },
  sectionChartData: {
    bar: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
    line: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
    pie: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
    map: { loading: false, error: null, data: null, type: 'receipt', hasData: false },
    stackedBar: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
  },
}

//  Define slice and it's reducer functions.
const monitorDashboardSlice = createSlice({
  name: "monitorDashboard",
  initialState,
  reducers: {
    setMonitorStock(state, action) {
      state.monitorStock = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setMonitorStockExport(state, action) {
      state.monitorStockExport = {
        error: action.payload.error,
        loading: action.payload.loading,
      }
    },
    setMonitorIps(state, action) {
      state.MonitorIps = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setMonitorProviderUsers(state, action) {
      state.monitorProviderUsers = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setMonitorItemCategories(state, action) {
      state.MonitorItemCategoires = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setMonitorCommodityClassifications(state, action) {
      state.MonitorCommodityClassifications = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setMonitorItems(state, action) {
      state.MonitorItems = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setMonitorInItems(state, action) {
      state.MonitorInItems = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setMonitorOutItems(state, action) {
      state.MonitorOutItems = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setMonitorIpsStock(state, action) {
      state.monitorIpsStock = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setMonitorIpsStockExport(state, action) {
      state.monitorIpsStockExport = {
        error: action.payload.error,
        loading: action.payload.loading,
      }
    },
    setMonitorWarehouses(state, action) {
      state.monitorWarehouses = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setMonitorProviders(state, action) {
      state.monitorProviders = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setMonitorProvinces(state, action) {
      state.monitorProvinces = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setMonitorFacilities(state, action) {
      state.monitorFacilities = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setMonitorProjects(state, action) {
      state.monitorProjects = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    resetMonitorStock(state) {
      state.monitorStock = { error: null, loading: false, data: [] }
    },
    resetMonitorIps(state) {
      state.MonitorIps = { error: null, loading: false, data: [] }
    },
    resetMonitorItemCategories(state) {
      state.MonitorItemCategoires = { error: null, loading: false, data: [] }
    },
    resetMonitorItems(state) {
      state.MonitorItems = { error: null, loading: false, data: [] }
    },
    resetMonitorInItems(state) {
      state.MonitorInItems = { data: [], error: null, loading: null }
    },
    resetMonitorOutItems(state) {
      state.MonitorOutItems = { data: [], error: null, loading: null }
    },
    resetMonitorIpsStock(state) {
      state.monitorIpsStock = { data: [], error: null, loading: null }
    },
    resetMonitorWarehouses(state) {
      state.monitorWarehouses = { data: [], error: null, loading: null }
    },
    resetMonitorProviders(state) {
      state.monitorMonitors = { data: [], error: null, loading: null }
    },
    resetMonitorProvinces(state) {
      state.monitorProvinces = { data: [], error: null, loading: null }
    },
    resetMonitorFacilities(state) {
      state.monitorFacilities = { data: [], error: null, loading: null }
    },
    resetMonitorProjects(state) {
      state.monitorProjects = { data: [], error: null, loading: null }
    },
    resetMonitorStockExport(state) {
      state.monitorStockExport = { error: null, loading: null }
    },
    resetMonitorIPsStockExport(state) {
      state.monitorIpsStockExport = { error: null, loading: false }
    },
    resetMonitorProviderUsers(state) {
      state.monitorProviderUsers = { error: null, loading: false, data: [] }
    },
    setMonitorFundCodes(state, action) {
      state.monitorFundCodes = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    setMonitorShipments(state, action) {
      state.monitorShipments = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      }
    },
    resetMonitorFundCodes(state) {
      state.monitorFundCodes = { error: null, loading: false, data: [] }
    },
    resetMonitorShipments(state) {
      state.monitorShipments = { error: null, loading: false, data: [] }
    },
    setMonitorDashboardConfig(state, action) {
      state.monitorDashboardConfig = {
        loading: action.payload.loading ?? false,
        error: action.payload.error ?? null,
        data: action.payload.data ?? null,
      }
    },
    setRealtimeExportState(state, action) {
      state.realtime.exportState = action.payload
    },
    setSectionChartData(state, action) {
      const { section } = action.payload
      if (section && state.sectionChartData[section] !== undefined) {
        state.sectionChartData[section] = {
          ...state.sectionChartData[section],
          ...action.payload,
        }
      }
    },
    resetSectionChartData(state, action) {
      const section = action.payload
      if (section && state.sectionChartData[section] !== undefined) {
        const defaults = {
          bar: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
          line: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
          pie: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
          map: { loading: false, error: null, data: null, type: 'receipt', hasData: false },
          stackedBar: { loading: false, error: null, data: null, dataset: 'stock', hasData: false },
        }
        state.sectionChartData[section] = defaults[section] || { loading: false, error: null, data: null }
      }
    },
  },
})

export const monitorDashboardAction = monitorDashboardSlice.actions

export default monitorDashboardSlice
